import { render, staticRenderFns } from "./Escritorios.vue?vue&type=template&id=5a408e72&scoped=true"
import script from "./Escritorios.vue?vue&type=script&lang=js"
export * from "./Escritorios.vue?vue&type=script&lang=js"
import style0 from "./Escritorios.vue?vue&type=style&index=0&id=5a408e72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a408e72",
  null
  
)

export default component.exports